export default __webpack_public_path__ + "static/media/t3.c1a3397f.jpeg";